const GRID_CELL_CLASSNAME = 'ag-cell'

/**
 * Get all focusable elements inside a given element.
 */
const getAllFocusableElementsOf = (el) => {
  const selectors = [
    'button',
    'a[href]', // anchor with href
    'a[tabindex]', // anchor without href but explicitly made focusable
    'input',
    'select',
    'textarea',
    "[tabindex]:not([tabindex='-1'])",
  ]

  return Array.from(el.querySelectorAll(selectors.join(','))).filter((el) => {
    return !el.disabled && el.tabIndex >= 0 && isElementVisible(el)
  })
}
function isElementVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)
}

/**
 * Get the path of elements from the event target up to the root.
 */
const getEventPath = (event) => {
  const path = []
  let current = event.target
  while (current) {
    path.push(current)
    current = current.parentElement
  }
  return path
}

/**
 * Handle keyboard navigation within a grid cell and suppress event if needed.
 */
export const suppressKeyboardEvent = ({ event }) => {
  const { key, shiftKey } = event
  const isTab = key === 'Tab'
  const isForward = isTab && !shiftKey
  const isBackward = isTab && shiftKey

  if (!isTab) return false

  const path = getEventPath(event)
  const eGridCell = path.find((el) =>
    el.classList?.contains(GRID_CELL_CLASSNAME),
  )

  if (!eGridCell) return false

  const focusableElements = getAllFocusableElementsOf(eGridCell)
  if (focusableElements.length === 0) return false

  const currentIndex = focusableElements.indexOf(document.activeElement)
  const firstElement = focusableElements[0]
  const lastElement = focusableElements[focusableElements.length - 1]

  if (isForward) {
    const isLast = document.activeElement === lastElement
    if (!isLast) {
      event.preventDefault()
      const nextElement = focusableElements[currentIndex + 1]
      if (nextElement) nextElement.focus()
      return true
    }
  } else if (isBackward) {
    const isFirst = document.activeElement === firstElement
    const isChildFocused =
      eGridCell.contains(document.activeElement) &&
      document.activeElement !== eGridCell

    if (!isChildFocused) {
      lastElement.focus()
      event.preventDefault()
      return true
    }

    if (!isFirst) {
      event.preventDefault()
      const prevElement = focusableElements[currentIndex - 1]
      if (prevElement) prevElement.focus()
      return true
    }
  }

  return false
}
